import { zodResolver } from '@hookform/resolvers/zod';
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
  UseFormReturn,
} from 'react-hook-form';
import { IEsgDataPlatformFormValues } from './types';
import { EsgDataPlatformSchema } from './validators';

type EsgPlatformContext = UseFormReturn<IEsgDataPlatformFormValues>;

type EsgPlatformFormSubmission = (
  formUtils: EsgPlatformContext
) => SubmitHandler<IEsgDataPlatformFormValues>;

type EsgPlatformFormProviderType = {
  children: React.ReactNode;
  onSubmit?: EsgPlatformFormSubmission;
  initialValues?: IEsgDataPlatformFormValues;
};

const useEsgPlatformForm = useFormContext<IEsgDataPlatformFormValues>;

const defaultFormValues: IEsgDataPlatformFormValues = {
  isAllCompletedTh: false,
  isAllCompletedEn: false,
} as IEsgDataPlatformFormValues;

const EsgPlatformFormProvider = (props: EsgPlatformFormProviderType) => {
  const { children, onSubmit, initialValues } = props;
  const formContext = useForm<IEsgDataPlatformFormValues>({
    mode: 'onChange',
    resolver: zodResolver(EsgDataPlatformSchema),
    defaultValues: initialValues ?? defaultFormValues,
  });

  return (
    <FormProvider {...formContext}>
      <form
        onSubmit={
          typeof onSubmit === 'function'
            ? formContext.handleSubmit(onSubmit(formContext))
            : undefined
        }
        style={{ width: '100%' }}
        noValidate
      >
        {children}
      </form>
    </FormProvider>
  );
};

export { useEsgPlatformForm };
export default EsgPlatformFormProvider;
